import React from 'react';
import '../styles/Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      category: 'AI / ML',
      skills: [
        { name: 'Computer Vision', level: 90 },
        { name: 'NLP', level: 86 },
        { name: 'Generative AI', level: 88 },
        { name: 'Agentic AI', level: 90 },
        { name: 'Multi-Agent Systems', level: 88 },
        { name: 'LLM Orchestration', level: 89 },
        { name: 'RAG Systems', level: 87 },
        { name: 'AI System Design', level: 85 },
        { name: 'MLOps', level: 80 }
      ]
    },
    {
      category: 'Programming',
      skills: [
        { name: 'Python', level: 95 },
        { name: 'C++', level: 75 },
        { name: 'MATLAB', level: 70 },
        { name: 'JavaScript', level: 78 },
        { name: 'SQL', level: 76 },
        { name: 'Bash', level: 72 }
      ]
    },
    {
      category: 'Frameworks',
      skills: [
        { name: 'PyTorch', level: 90 },
        { name: 'TensorFlow', level: 84 },
        { name: 'OpenCV', level: 88 },
        { name: 'Hugging Face', level: 86 },
        { name: 'LangChain', level: 90 },
        { name: 'LangGraph', level: 90 },
        { name: 'llama-cpp', level: 82 }
      ]
    },
    {
      category: 'Tools',
      skills: [
        { name: 'Docker', level: 72 },
        { name: 'Streamlit', level: 88 },
        { name: 'Git', level: 85 },
        { name: 'GitHub Actions', level: 80 },
        { name: 'Frigate', level: 74 }
      ]
    },
    {
      category: 'Cloud',
      skills: [
        { name: 'AWS SageMaker', level: 82 },
        { name: 'Google Cloud AI Platform', level: 74 }
      ]
    }
  ];

  const softSkills = [
    'Leadership',
    'Team Collaboration',
    'Technical Training',
    'Communication',
    'Research',
    'Time Management'
  ];

  const languages = [
    { name: 'Arabic', level: 'Native' },
    { name: 'English', level: 'Proficient' },
    { name: 'German', level: 'Beginner' }
  ];

  return (
    <section className="skills" id="skills">
      <div className="container">
        <h2>Skills & Technologies</h2>
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <h3>{category.category}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-info">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div
                        className="skill-progress"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className="skill-category">
            <h3>Soft Skills</h3>
            <div className="soft-skills-list">
              {softSkills.map((skill) => (
                <span key={skill} className="soft-skill-tag">
                  {skill}
                </span>
              ))}
            </div>
          </div>
          <div className="skill-category">
            <h3>Languages</h3>
            <div className="skills-list">
              {languages.map((language) => (
                <div key={language.name} className="language-item">
                  <span className="skill-name">{language.name}</span>
                  <span className="language-badge">{language.level}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
